import { JsonServiceClient } from '@servicestack/client';
import { useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { client } from '../api/client';
import { GetSponsors, GetSponsorsResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetSponsorsResponse, GetSponsorsResponse>) => response?.data?.sponsors;

const getError = (response?: SWRResponse<GetSponsorsResponse, GetSponsorsResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetSponsorsResponse, GetSponsorsResponse>) => ({
    sponsors: response?.data?.sponsors,
    count: response?.data?.count
});

export const useSponsors = (id?: number, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        
        return () => {
            return new GetSponsors({});
        };
    }, [id])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useSponsors;